module.exports = __webpack_public_path__ + "components/MapControl/svg/Bunkier.svg?6063a050";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Bunkier.svg
// module id = 2019
// module chunks = 0